import React from 'react';
import { Box, Container, Grid, Typography, Stack, Divider, IconButton, Button } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: '#F1F5F9', pt: 10, pb: 4, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
      <Container maxWidth="xl">
        <Grid container spacing={6}>
          <Grid item xs={12} md={4}>
            <Typography variant="h5" sx={{ fontWeight: 900, color: 'primary.main', mb: 3, letterSpacing: '-1px' }}>NitiX</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 2, mb: 4, maxWidth: 300 }}>
              The intelligence layer powering the future of governance. Bringing together data, intelligence, and automation for sovereign public systems.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(0,0,0,0.03)', '&:hover': { bgcolor: 'primary.main', color: '#fff' } }}><LinkedInIcon /></IconButton>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(0,0,0,0.03)', '&:hover': { bgcolor: 'primary.main', color: '#fff' } }}><TwitterIcon /></IconButton>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(0,0,0,0.03)', '&:hover': { bgcolor: 'primary.main', color: '#fff' } }}><GitHubIcon /></IconButton>
            </Stack>
          </Grid>
          
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 3 }}>Platforms</Typography>
            <Stack spacing={1.5}>
              <NavLink to="/technology" style={{ color: '#64748B', textDecoration: 'none', fontSize: '0.85rem' }}>Technology</NavLink>
              <NavLink to="/platform" style={{ color: '#64748B', textDecoration: 'none', fontSize: '0.85rem' }}>Architecture</NavLink>
              <NavLink to="/solutions" style={{ color: '#64748B', textDecoration: 'none', fontSize: '0.85rem' }}>Solutions</NavLink>
              <NavLink to="/use-cases" style={{ color: '#64748B', textDecoration: 'none', fontSize: '0.85rem' }}>Use Cases</NavLink>
            </Stack>
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 3 }}>Resources</Typography>
            <Stack spacing={1.5}>
              <NavLink to="/about" style={{ color: '#64748B', textDecoration: 'none', fontSize: '0.85rem' }}>Our Vision</NavLink>
              <NavLink to="/insights" style={{ color: '#64748B', textDecoration: 'none', fontSize: '0.85rem' }}>Insights</NavLink>
              <NavLink to="/case-studies" style={{ color: '#64748B', textDecoration: 'none', fontSize: '0.85rem' }}>Case Studies</NavLink>
              <NavLink to="/partners" style={{ color: '#64748B', textDecoration: 'none', fontSize: '0.85rem' }}>Partners</NavLink>
              <NavLink to="/careers" style={{ color: '#64748B', textDecoration: 'none', fontSize: '0.85rem' }}>Careers</NavLink>
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ p: 4, bgcolor: 'rgba(0,124,255,0.03)', borderRadius: 2, border: '1px solid rgba(0,124,255,0.1)' }}>
               <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 2, color: 'text.primary' }}>Ready to Transform?</Typography>
               <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>Schedule a consultation with our governance AI experts.</Typography>
               <Button variant="contained" fullWidth sx={{ borderRadius: '8px', fontWeight: 800, py: 1.5 }} onClick={() => navigate('/contact')}>Start Conversation</Button>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ mt: 8, mb: 4, opacity: 0.1 }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            © {new Date().getFullYear()} NitiX AI. All Rights Reserved. | DPDP & ISO Certified
          </Typography>
          <Stack direction="row" spacing={3}>
             <Typography variant="caption" sx={{ color: 'text.secondary', cursor: 'pointer' }}>Privacy Policy</Typography>
             <Typography variant="caption" sx={{ color: 'text.secondary', cursor: 'pointer' }}>Terms of Service</Typography>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
